module.exports = __webpack_public_path__ + "static/media/CORBATAS_MENU-normal.ff52385f.png";